import { ClarityType } from '../constants';

var trueCV = function trueCV() {
  return {
    type: ClarityType.BoolTrue
  };
};

var falseCV = function falseCV() {
  return {
    type: ClarityType.BoolFalse
  };
};

export { trueCV, falseCV };